module.exports = __webpack_public_path__ + "static/media/jpeg-icon.5f6768b2.svg";